import React, { useState, useEffect, useContext } from "react";

// alphabetized
import Modal from "react-bootstrap/Modal";
import SaveSpinnerButton from "./save_spinner_button";
import useCompanyUpdateApi from "../data/use_company_update_api";
import { CompanyContext } from "../data/company_context_management";

// The show/hide switch for a PR agency's "Our PR Team" section, scoped to the one page_config key
// that section reads. Reached from the section's own pen and from the "Add a section" dropdown once
// it is switched off; the Main Content modal still carries the same switch alongside the others.
function PrTeamForm() {
  const context = useContext(CompanyContext);
  const { company, isUpdating, setOpenEditModal, setGeneralError } = context;
  const { updateCompany } = useCompanyUpdateApi({ ...context });
  const [showValue, setShowValue] = useState(!!company.page_config?.show_prs);

  // Saving closes this modal as soon as the PATCH succeeds — before the read that follows it lands.
  // Re-seed the switch whenever that read replaces `company`, so reopening the form can never show a
  // value from before the last save.
  useEffect(() => {
    setShowValue(!!company.page_config?.show_prs);
  }, [company]);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const handleShowChange = (e) => {
    setShowValue(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const pageConfig = {
      ...company.page_config,
      show_prs: showValue,
    };

    updateCompany({ page_config: pageConfig });
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="form-check form-switch">
            <label className="form-check-label" htmlFor="show_prs">
              Show this section&nbsp;
              <small>(It&apos;s automatically generated)</small>
              <input
                type="checkbox"
                className="form-check-input"
                checked={showValue}
                onChange={handleShowChange}
                disabled={isUpdating}
                id="show_prs"
              />
            </label>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save Changes"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit}
        />
        <button type="button" className="btn text-danger" onClick={closeModal} disabled={isUpdating}>
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}

export default PrTeamForm;
